<template>
  <div class="tw-w-full tw-rounded-2xl tw-border tw-border-white/40 tw-bg-white/50 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4 sm:tw-p-5">
    <div class="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-end sm:tw-justify-between">
      <div class="tw-min-w-0">
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-2">
          <h1 class="tw-text-2xl sm:tw-text-3xl tw-font-semibold tw-tracking-tight tw-text-slate-800">Order # {{ order.id }}</h1>

          <span
            v-if="!order.isExport && order.billOfLading"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
          >
            BL# {{ order.billOfLading.billOfLadingId }}
          </span>

          <span
            v-if="order.houseBillOfLading && order.houseBillOfLading != ''"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
          >
            HBL# {{ order.houseBillOfLading }}
          </span>

          <span
            v-else-if="order.bookingNumber"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
          >
            BKG # {{ order.bookingNumber }}
          </span>
        </div>

        <div class="tw-mt-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2">
          <span class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600">
            {{ order.containers.length }} {{ order.isExport ? 'Export(s)' : 'Import(s)' }}
          </span>

          <span
            v-if="order.isDropHook"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
          >
            Drop and Hook
          </span>
          <span
            v-else-if="isRailPickUp"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
          >
            Rail Pick-Up
          </span>
          <span
            v-else-if="isRailDelivery"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
          >
            Rail Delivery
          </span>
          <span
            v-else-if="isDomestic"
            class="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
          >
            Load(s)
          </span>
        </div>
      </div>

      <div class="tw-text-sm tw-text-slate-600">Created on: {{ order.createdAt }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    order: {
      type: Object,
    },
    showAvailabilityButton: {
      default: false,
    },
  },
  computed: {
    isExport(): boolean {
      return this.order.orderType === 'Export';
    },
    isImport(): boolean {
      return this.order.orderType === 'Import';
    },
    isRailPickUp(): boolean {
      return this.order.orderType === 'RailPickUp';
    },
    isRailDelivery(): boolean {
      return this.order.orderType === 'RailDelivery';
    },
    isDomestic(): boolean {
      return this.order.orderType === 'Domestic';
    },
  },
});
</script>
